import React from 'react';
import styled from 'styled-components';

const StyledDiv = styled.div`
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Loader = () => {
  return (
    <StyledDiv>
      <img
        alt=""
        src="https://r.r10s.jp/com/img/rms/storefront/pc/page/smart/loading_icon2.gif"
      />
    </StyledDiv>
  );
};
